<lib-modal-layout [title]="'Select Wholesaler'" [subtitle]="''">
  <p class="text-center large">Use the dropdown below to select the wholesale tenant for your quote.</p>
  <div class="flex flex-col items-center justify-center my-4">
    <lib-form-dropdown
      class="w-3/5"
      [formControl]="tenantId"
      [label]="'Wholesale Tenant'"
      [options]="tenants()"
    ></lib-form-dropdown>
  </div>
  <p class="large text-center mb-7">Click continue to proceed to the quote.</p>
  <lib-button
    btnPrimary
    [cssType]="'btn-primary'"
    [text]="'Continue'"
    [type]="'submit'"
    [icon]="'rightarrow'"
    [disabled]="!tenantId.value"
    (click)="onSubmit()"
  ></lib-button>
</lib-modal-layout>